import { PixelsJS } from '../../types/pixelsjs';

const { pixelsjs } = window;
const Plugin = pixelsjs.getPlugin('plugin');

class PixelsUI extends Plugin {
 constructor(player: PixelsJS) {
    super(player);
  }
}

pixelsjs.registerPlugin('pixelsUI', PixelsUI);
